import {
  HAPTIC_INTENSITY_MAX,
  HAPTIC_INTENSITY_MIN,
  HAPTIC_PULSE_MS,
  HAPTIC_SPEED_NORM_MPS,
} from '../config/constants';

/**
 * Controller haptic pulse on hit (Q9c).
 * Intensity scales with tip speed; duration fixed.
 */
export function pulseControllerHaptic(
  inputSource: XRInputSource | null | undefined,
  tipSpeedMPerSec: number,
  durationMs: number = HAPTIC_PULSE_MS,
): void {
  if (!inputSource) return;
  const gp = inputSource.gamepad;
  if (!gp) return;
  const actuators = (gp as Gamepad & { hapticActuators?: GamepadHapticActuator[] }).hapticActuators;
  const actuator = actuators?.[0];
  if (!actuator || typeof actuator.pulse !== 'function') return;

  const intensity = clamp(
    tipSpeedMPerSec / HAPTIC_SPEED_NORM_MPS,
    HAPTIC_INTENSITY_MIN,
    HAPTIC_INTENSITY_MAX,
  );
  actuator.pulse(intensity, durationMs).catch(() => {
    /* ignore */
  });
}

function clamp(v: number, lo: number, hi: number): number {
  return Math.min(hi, Math.max(lo, v));
}
